import identityContractJson from './lrp-assumption-driver-identity.json';

export type LrpAssumptionDriverIdentity = {
  parameter: string;
  requiredConceptGroups: readonly (readonly string[])[];
};

type LrpAssumptionDriverIdentityContract = {
  schemaVersion: string;
  drivers: readonly LrpAssumptionDriverIdentity[];
};

const identityContract =
  identityContractJson as LrpAssumptionDriverIdentityContract;

export const LRP_ASSUMPTION_DRIVER_IDENTITY_SCHEMA_VERSION =
  identityContract.schemaVersion;

export const LRP_ASSUMPTION_DRIVER_IDENTITIES =
  identityContract.drivers;

function normalizeConceptText(value: string): string {
  return value
    .toLocaleLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function containsConcept(value: string, concept: string): boolean {
  const normalizedValue = ` ${normalizeConceptText(value)} `;
  const normalizedConcept = normalizeConceptText(concept);
  return Boolean(
    normalizedConcept &&
      normalizedValue.includes(` ${normalizedConcept} `),
  );
}

export function matchesLrpAssumptionDriverIdentity(
  value: string,
  parameter: string,
): boolean {
  const publicProse = value.replace(/\{\{\s*n:[^}]+\}\}/gi, ' ');
  const normalizedParameter = normalizeConceptText(parameter);
  const identity = identityContract.drivers.find(
    (candidate) =>
      normalizeConceptText(candidate.parameter) === normalizedParameter,
  );
  if (!identity || identity.requiredConceptGroups.length === 0) return false;
  return identity.requiredConceptGroups.every(
    (group) =>
      group.length > 0 &&
      group.some((concept) => containsConcept(publicProse, concept)),
  );
}
